import moment from 'moment-timezone';

class TimeZone {
  public static getTimezone = () => {
    return moment.tz.guess();
  };

  public static getEncodedTimeZone = () => {
    return encodeURIComponent(moment.tz.guess());
  };
}

export default TimeZone;
